import { getCanonicalLocales } from '@formatjs/intl-getcanonicallocales';

import { select } from '../../../index';
import type { Model, RootState, SelectorCreator, Slicer } from '../../types';

export type LocaleState = string;

const reducers = {
  set: (state: LocaleState, payload?: string) => payload || state
};
const selectors = (slice: Slicer<LocaleState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  getIntlLocale() {
    return createSelector(
      slice,
      (rootState: RootState) => select.country.getCountry(rootState),
      (rootState: RootState) => select.account.getCountry(rootState),
      (rootState: RootState) => select.timeZone.getTimeZoneName(rootState),
      (state, geoCountry, accountCountry, timeZone) => {
        const country = accountCountry || geoCountry;
        try {
          let [locale] = getCanonicalLocales(`${state}-${country}`);
          if (
            locale.startsWith('en') &&
            locale !== 'en' &&
            locale !== 'en-INTERNAL' &&
            timeZone.startsWith('Europe') &&
            Intl.DateTimeFormat(locale).resolvedOptions().locale === 'en'
          ) {
            locale = 'en-GB';
          }
          return locale;
        } catch {
          return state;
        }
      }
    );
  }
});

const locale: Model<LocaleState, typeof reducers, void, void, typeof selectors> = {
  state: 'en',
  reducers,
  selectors
};

export default locale;
